import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AIIslandScopeSelector } from './AIIslandScopeSelector';
import { AIIslandEmptyState } from './AIIslandEmptyState';
import { AIIslandResponse } from './AIIslandResponse';
import { AIIslandActionBar } from './AIIslandActionBar';
import { useDrawerSnap } from './hooks/useDrawerSnap';

export function AIIslandDrawer({
  height,
  onHeightChange,
  onCollapse,
  onNewPrompt,
  mode,
  onModeChange,
  response,
  isStreaming,
  actions,
  modes,
  responseLabels,
  promptValue,
  emptyState,
  selection,
  onTaskSelect,
  newPromptLabel,
  children,
}) {
  const { t } = useTranslation();
  const { handleDragStart } = useDrawerSnap({
    heights: ['collapsed', 'half', 'full'],
    current: height,
    onChange: onHeightChange,
  });
  const showEmptyState = !response && !isStreaming && !(promptValue || '').trim();

  return (
    <div className="ai-island-drawer" data-height={height} role="dialog" aria-label={t('reports.review.assistantTitle')}>
      <div
        className="ai-island-drawer__handle"
        onMouseDown={handleDragStart}
        onTouchStart={handleDragStart}
      >
        <div className="ai-island-drawer__handle-bar" />
      </div>
      <div className="ai-island-drawer__header">
        <AIIslandScopeSelector value={mode} onChange={onModeChange} scopes={modes} />
        <div className="ai-island-drawer__header-actions">
          {!showEmptyState && typeof onNewPrompt === 'function' && (
            <button
              type="button"
              className="ai-island-drawer__new-prompt"
              onClick={onNewPrompt}
            >
              {newPromptLabel || t('reports.aiIsland.actions.newPrompt')}
            </button>
          )}
          <button
            type="button"
            className="ai-island-drawer__collapse"
            onClick={onCollapse}
            aria-label={t('common.collapse')}
          >
            <ChevronDown size={16} />
          </button>
        </div>
      </div>
      <div className="ai-island-drawer__content">
        {showEmptyState ? (
          <AIIslandEmptyState
            selection={selection}
            selectionLabel={emptyState?.selectionLabel}
            tasksTitle={emptyState?.tasksTitle}
            tasks={emptyState?.tasks}
            onTaskSelect={onTaskSelect}
          />
        ) : (
          <AIIslandResponse
            response={response}
            isStreaming={isStreaming}
            responseLabel={responseLabels?.title}
            emptyLabel={responseLabels?.empty}
            diffLabels={responseLabels?.diff}
            streamingLabel={responseLabels?.streaming}
            onAcceptAll={actions.acceptAll}
            onAcceptChunk={actions.acceptChunk}
          />
        )}
      </div>
      <div className="ai-island-drawer__input">{children}</div>
      {response && <AIIslandActionBar response={response} actions={actions} labels={responseLabels?.actions} />}
    </div>
  );
}
